export default function IEObjectfitFallback () {
  // IE & Edge fallback for object-fit images
  const image = $('.product-images__item, .poi-images__item, .swiper-slide, .showcase-row__img, .object-fit');

  if ('objectFit' in document.documentElement.style === false) {
    $.each(image, function () {
      const $imageWrap = $(this),
        imgUrl = $imageWrap.find('img').prop('src');

      if (imgUrl) {
        $imageWrap
          .css('backgroundImage', 'url(' + imgUrl + ')')
          .addClass('objectfit-polyfill')
          .find('img').css('visibility', 'hidden');
      }
    });
  }
}



// WEBPACK FOOTER //
// ./app/webpack/packs/javascripts/shared/IEObjectfitFallback.js